<template>
  <tr :style="deathForSend > 0 ? 'background-color: #d6d6d6' : ''">
    <td class="align-middle" style="width: 140px">{{ member.info.nick }}</td>
    <td class="align-middle mr-2">{{ totalKills }}</td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:killForSend', killForSend + 1)"
             variant="primary"
             class="p-1 mr-4">
        <i class="fa fa-caret-up p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:killForSend', killForSend - 1)"
             variant="danger"
             class="p-1 mr-4">
        <i class="fa fa-caret-down p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:deathForSend', deathForSend > 0 ? 0 : 1)"
             :variant="deathForSend > 0 ? 'dark' : 'primary'"
             class="px-2 mr-4">
        {{ deathForSend > 0 ? 'Нет' : 'Да' }}
      </b-btn>
    </td>
  </tr>
</template>

<script>
/**
 * Строка игрока. Компонент ничего не отправляет на бэкенд: результаты копятся
 * в родителе (HostsLive) и уходят одним запросом по кнопке Send всей команды.
 */
export default {
  name: "RowInHostsBook",
  props: {
    member: {
      type: Object,
      default: null
    },
    /** Незаписанные киллы игрока (дельта к member.kills). */
    killForSend: {
      type: Number,
      default: 0
    },
    /** Незаписанный статус игрока: 1 — не жив, 0 — жив. */
    deathForSend: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    totalKills() {
      return (this.member?.kills ?? 0) + this.killForSend;
    },
  },
}
</script>

<style scoped>

</style>
